import { memo } from "react";
import { Flex } from "../flex";
import { Tooltip } from "../tooltip/tooltip";
import { RedoTooltipProps } from "./tooltip";

interface OptionalTooltipProps {
  meetsCondition: boolean;
  children: React.ReactElement;
  tooltipProps: Omit<RedoTooltipProps, "children">;
  wrapperClass?: string;
  wrapperStyle?: React.CSSProperties;
}

export const OptionalTooltip = memo(function OptionalTooltip({
  meetsCondition,
  children,
  tooltipProps,
  wrapperClass,
  wrapperStyle,
}: OptionalTooltipProps): React.ReactElement {
  if (meetsCondition) {
    return (
      <Tooltip {...tooltipProps}>
        <Flex as="span" className={wrapperClass} style={wrapperStyle}>
          {children}
        </Flex>
      </Tooltip>
    );
  } else {
    return (
      <Flex as="span" className={wrapperClass} style={wrapperStyle}>
        {children}
      </Flex>
    );
  }
});
